import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface LatestCostMonth {
  latestMonth: string | null;
  lastUpdatedAt: string | null;
}

@Injectable({ providedIn: 'root' })
export class LatestCostMonthService {
  constructor(private http: HttpClient) {}

  getLatestCostMonth(): Observable<LatestCostMonth> {
    return this.http.get<LatestCostMonth>('/clusters/cost/cluster/latest-month');
  }
}
